import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import Skeleton from '@mui/material/Skeleton';

import ListItemSelectionMark from '@ts-core/components/ListItemSelectionMark';
import SubjectSecondaryActionMenu from './SubjectSecondaryActionMenu';
import SubjectIcon from './SubjectIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';

const SubjectListItem = (props) => {
  const {
    subject,
    loading,
    selected,
    open,
    showSelectedMark,
    onClick,
    menuOpen,
    onOpenMenu,
    onCloseMenu,
    onAddSubject,
    onEditSubject,
    onRemoveSubject,
    onToggleSubject,
    children,
  } = props;

  const handleClick = useCallback(() => {
    onClick(subject);
  }, [subject, onClick]);

  return (
    <div>
      <ListItem
        button
        onClick={handleClick}
        selected={selected}
        sx={{
          '&.Mui-selected': {
            backgroundColor: 'background.paper',
          },
          '&.Mui-selected: hover': {
            backgroundColor: 'background.paper',
          },
        }}
      >
        {showSelectedMark && selected && <ListItemSelectionMark />}
        <Box mr={1}>{loading ? <Skeleton variant="rectangular" height={24} width={24} /> : <SubjectIcon subject={subject} open={open} />}</Box>
        {loading ? <Skeleton width={100} /> : <ListItemText primary={subject.name} style={{ marginRight: 54 }} />}
        {!loading && (
          <ListItemSecondaryAction>
            <SubjectSecondaryActionMenu
              subject={subject}
              open={menuOpen}
              onOpen={onOpenMenu}
              onClose={onCloseMenu}
              onAddSubject={onAddSubject}
              onEditSubject={onEditSubject}
              onRemoveSubject={onRemoveSubject}
              onToggleSubject={onToggleSubject}
            />
          </ListItemSecondaryAction>
        )}
      </ListItem>
      {children}
    </div>
  );
};

SubjectListItem.propTypes = {
  children: PropTypes.node.isRequired,
  subject: PropTypes.object,
  loading: PropTypes.bool,
  selected: PropTypes.bool,
  open: PropTypes.bool,
  showSelectedMark: PropTypes.bool,
  menuOpen: PropTypes.bool,

  onClick: PropTypes.func.isRequired,
  onOpenMenu: PropTypes.func.isRequired,
  onCloseMenu: PropTypes.func.isRequired,

  onAddSubject: PropTypes.func,
  onEditSubject: PropTypes.func,
  onRemoveSubject: PropTypes.func,
  onToggleSubject: PropTypes.func,
};

SubjectListItem.defaultProps = {
  subject: {},
  loading: false,
  selected: false,
  open: false,
  showSelectedMark: false,
  menuOpen: false,

  onAddSubject: undefined,
  onEditSubject: undefined,
  onRemoveSubject: undefined,
  onToggleSubject: undefined,
};

export default SortableElement(SubjectListItem);
